import { Component, OnInit, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Globals } from './_globals/globals';

import { AuthenticationService } from './_services/Authentication.service';

import { User } from './_models/user';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import * as fromUser from './user/state/user.reducer';
import * as fromRoot from './state/app.reducer';
import * as userActions from './user/state/user.actions';
import * as fileActions from './file/state/file.actions';
import * as optiActions from './opti/state/opti.actions';
import * as cuttingTableActions from './maestros/cutting_table/state/cutting_table.actions';
import * as easelActions from './maestros/easel/state/easel.actions';
import * as reasonActions from './maestros/reason/state/reason.actions';
import * as rootActions from './state/app.actions';
import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Translation } from './_languages/translations';
import { OptiService } from './opti/opti.service';
import { classifyOptimizationResults } from './opti/optimization-result-classifier';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {

  // Para el control del diccionario de traducción.
  languageOption: string;
  vocabulary$: Observable<{}>;
  tr: {};

  currentUser: User;
  toggleNav: boolean;
  toggleModal: boolean;
  error = '';

  loading: boolean;
  loading1: boolean;
  loading2: boolean;
  loading3: boolean;
  loading4: boolean;
  loading5: boolean;
  loading6: boolean;

  alertModal: boolean;
  alertInfo: string;

  infoModal: boolean;
  infoInfo: string;
  linkInfo: string;
  paramInfo: any;
  skinInfo: string;

  button_color: string;

  componentActive = true;

  setTimeoutConfirmModal: number;
  optimizationVisualProgress: number;
  optimizationVisualIteration: number;
  optimizationVisualAttempts: number;
  optimizationVisualStartTs: number;
  optimizationVisualElapsedText: string;
  optimizationVisualSpeedLabel: string;
  optimizationVisualSheets: number;
  optimizationCancelRequested: boolean;
  optimizationVisualTimer: any;
  optimizationVisualActive: boolean;
  autoExecOverlayVisible: boolean;
  autoExecOverlayCurrentMaterial: string;
  autoExecOverlayCompleted: number;
  autoExecOverlayTotal: number;
  autoExecOverlayPending: number;
  autoExecOverlayPercent: number;
  autoExecOverlayCurrentStep: number;
  autoExecOverlayPulse: number;
  autoExecOverlayElapsedText: string;
  autoExecOverlayHeartbeatText: string;
  autoExecOverlayStalled: boolean;
  autoExecOverlayTimer: any;
  optimizerQueueModal: boolean;
  optimizerQueueJobs: any[];
  optimizerQueueTimer: any;
  optimizerQueueHasAttention: boolean;
  optimizerQueueActiveCount: number;
  optimizerQueueFilter: string;
  optimizerQueuePolling: boolean;
  optimizerQueueClearing: boolean;
  optimizerQueueEventHandler: any;
  optimizerQueueResultModal: boolean;
  optimizerQueueSelectedJob: any;
  optimizerQueueCanvasModal: boolean;
  optimizerQueueCanvasResult: any;
  optimizerQueueLastPollAt: Date;
  optimizerQueueClockMs: number;
  optimizerQueuePreviewLoadingKey: string;
  optimizerQueuePreviewLoadingMessage: string;
  optimizerQueueShowDiscarded: boolean;
  optimizerStopModal: boolean;
  optimizerStopJob: any;
  optimizerStopSubmitting: boolean;
  optimizerStopPendingJobId: string;
  

  constructor(
    private globals: Globals,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private store: Store<fromUser.State>,
    private storeRoot: Store<fromRoot.State>,
    private router: Router,
    public trans: Translation,
    private optiService: OptiService,
    // NOTA: variable necesaria para evitar el error de chequeo por los "ngIf" cambiantes.
    private cdRef: ChangeDetectorRef
  ) {
        this.toggleNav = false;
        this.toggleModal = false;
        this.authenticationService.currentUser.subscribe(x => {
          this.currentUser = x;
          if (this.isManufacturer) {
            setTimeout(() => this.captureManufacturerGeolocation(), 0);
          }
        });

  }

  get isManufacturer(): boolean {
    return !!(this.currentUser && this.currentUser.permissions === 'Manufacturer');
  }

  get showDimproAssist(): boolean {
    return !!this.currentUser;
  }

  private sendClientContext(payloadIn: any): void {
    const timezone = Intl && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : '';
    const payload = Object.assign({}, payloadIn, {
      timezone: timezone || '',
      language: navigator.language || '',
      screen: window.screen ? (window.screen.width + 'x' + window.screen.height) : ''
    });
    this.http.post(this.globals.apiUrl + '/client_context', payload).subscribe(
      () => {},
      error => console.warn('No se pudo registrar el contexto de geolocalización.', error && error.status)
    );
  }

  private captureManufacturerGeolocation(): void {
    if (!this.currentUser || !this.currentUser.user_id) {
      return;
    }
    const sessionKey = 'manufacturer_geolocation_' + this.currentUser.user_id.toString();
    if (sessionStorage.getItem(sessionKey) === 'requested') {
      return;
    }
    sessionStorage.setItem(sessionKey, 'requested');

    if (!(window as any).isSecureContext) {
      this.sendClientContext({ status: 'insecure_context', reason: 'HTTPS requerido por el navegador.' });
      return;
    }
    if (!navigator.geolocation) {
      this.sendClientContext({ status: 'unsupported', reason: 'API de geolocalización no disponible.' });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        this.sendClientContext({
          status: 'granted',
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          captured_at: position.timestamp
        });
      },
      error => {
        const status = error.code === error.PERMISSION_DENIED
          ? 'denied'
          : (error.code === error.TIMEOUT ? 'timeout' : 'unavailable');
        this.sendClientContext({ status: status, reason: error.message || '' });
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  }

  // Función para evitar el error de chequeo por los "ngIf" cambiantes.
  ngAfterViewChecked() {
    // console.log('--> -> ngAfterViewChecked...');
    this.cdRef.detectChanges();
  }

  ngOnInit() {

    this.handleVsBudgetSessionProbe();
    
    // IMPORTANTE: pasar el entorno de la clase como parámetro para
    // que las funciones internas puedan reconocer y modificar las variables.
    let that = this;
    
    // Para el control del diccionario de traducción.
    this.vocabulary$ = this.trans.getVocabulary$();

    this.vocabulary$.subscribe(
      tr => {
            // console.log(' >>>> Diccionario para AppComponent: ');
            // console.log(tr);

            this.tr = tr;

            // Colocamos en el selector de lenguaje el indicado por la clase de traducción.
            this.languageOption = this.trans.actualLanguage;
          }
    );

    this.trans.changeLanguage(this.trans.actualLanguage);

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.loading = false;
    this.loading1 = false;
    this.loading2 = false;
    this.loading3 = false;
    this.loading4 = false;
    this.loading5 = false;
    this.loading6 = false;

    this.alertModal = false;
    this.alertInfo = '';
    this.infoModal = false;
    this.infoInfo = '';
    this.linkInfo = '';
    this.paramInfo = null;
    this.skinInfo = 'info';

    this.button_color = 'is-primary';
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 0;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = 0;
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = '-';
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    this.optimizationVisualTimer = null;
    this.optimizationVisualActive = false;
    this.autoExecOverlayVisible = false;
    this.autoExecOverlayCurrentMaterial = '';
    this.autoExecOverlayCompleted = 0;
    this.autoExecOverlayTotal = 0;
    this.autoExecOverlayPending = 0;
    this.autoExecOverlayPercent = 0;
    this.autoExecOverlayCurrentStep = 0;
    this.autoExecOverlayPulse = 0;
    this.autoExecOverlayElapsedText = '00:00';
    this.autoExecOverlayHeartbeatText = '-';
    this.autoExecOverlayStalled = false;
    this.autoExecOverlayTimer = null;
    this.optimizerQueueModal = false;
    this.optimizerQueueJobs = [];
    this.optimizerQueueTimer = null;
    this.optimizerQueueHasAttention = false;
    this.optimizerQueueActiveCount = 0;
    this.optimizerQueueFilter = 'active';
    this.optimizerQueuePolling = false;
    this.optimizerQueueClearing = false;
    this.optimizerQueueEventHandler = null;
    this.optimizerQueueResultModal = false;
    this.optimizerQueueSelectedJob = null;
    this.optimizerQueueCanvasModal = false;
    this.optimizerQueueCanvasResult = null;
    this.optimizerQueueLastPollAt = null;
    this.optimizerQueueClockMs = Date.now();
    this.optimizerQueuePreviewLoadingKey = '';
    this.optimizerQueuePreviewLoadingMessage = '';
    this.optimizerQueueShowDiscarded = false;
    this.optimizerStopModal = false;
    this.optimizerStopJob = null;
    this.optimizerStopSubmitting = false;
    this.optimizerStopPendingJobId = '';

    this.componentActive = true;

    // Tiempo que tardan en cerrarse las ventanas modales de información.
    this.setTimeoutConfirmModal = 2000;

    this.storeRoot.pipe(select(fromRoot.getLoading),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading => {
            // console.log(' >>>> Suscribirse a store loading: ');
            // console.log(loading);

            this.loading = loading;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading1),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading1 => {
            // console.log(' >>>> Suscribirse a store loading1: ');
            // console.log(loading1);

            this.loading1 = loading1;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading2),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading2 => {
            // console.log(' >>>> Suscribirse a store loading2: ');
            // console.log(loading2);

            this.loading2 = loading2;
          }
    );
    this.storeRoot.pipe(select(fromRoot.getLoading3),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading3 => {
            // console.log(' >>>> Suscribirse a store loading3: ');
            // console.log(loading3);

            this.loading3 = loading3;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading4),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading4 => {
            // console.log(' >>>> Suscribirse a store loading4: ');
            // console.log(loading4);

            this.loading4 = loading4;
          }
    );
    this.storeRoot.pipe(select(fromRoot.getLoading5),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading5 => {
            // console.log(' >>>> Suscribirse a store loading5: ');
            // console.log(loading5);

            this.loading5 = loading5;
            this.updateOptimizationVisualState();
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading6),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading6 => {
            // console.log(' >>>> Suscribirse a store loading6: ');
            // console.log(loading6);

            this.loading6 = loading6;
            this.updateOptimizationVisualState();
          }
    );

    this.storeRoot.pipe(select(fromRoot.getAlertModal),
      takeWhile(() => this.componentActive))
      .subscribe(
      alertModal => {
            // console.log(' >>>> Suscribirse a store alertModal: ');
            // console.log(alertModal);

            this.alertModal = alertModal;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getAlertInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      alertInfo => {
            // console.log(' >>>> Suscribirse a store alertInfo: ');
            // console.log(alertInfo);

            this.alertInfo = alertInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getInfoModal),
      takeWhile(() => this.componentActive))
      .subscribe(
      infoModal => {
            // console.log(' >>>> Suscribirse a store infoModal: ');
            // console.log(infoModal);

            this.infoModal = infoModal;

            // Para que la ventana se cierre automáticamente en X segundos.
            if (infoModal) {
              setTimeout(() => { this.confirmInfoModal()}, this.setTimeoutConfirmModal);
            }
          }
    );

    this.storeRoot.pipe(select(fromRoot.getInfoInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      infoInfo => {
            // console.log(' >>>> Suscribirse a store infoInfo: ');
            // console.log(infoInfo);

            this.infoInfo = infoInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLinkInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      linkInfo => {
            // console.log(' >>>> Suscribirse a store linkInfo: ');
            // console.log(linkInfo);

            this.linkInfo = linkInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getParamInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      paramInfo => {
            // console.log(' >>>> Suscribirse a store paramInfo: ');
            // console.log(paramInfo);

            this.paramInfo = paramInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getSkinInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      skinInfo => {
            // console.log(' >>>> Suscribirse a store skinInfo: ');
            // console.log(skinInfo);

            this.skinInfo = skinInfo;
            switch (skinInfo) {
              case 'info':
                this.button_color = 'is-primary';
                break;

              case 'alert':
                this.button_color = 'is-danger';
                break;

              default:
                this.button_color = 'is-primary';
                break;
            }
          }
    );

    this.startAutoExecOverlayLoop();
    this.startOptimizerQueueLoop();
    this.registerOptimizerQueueEvents();
  }

  private handleVsBudgetSessionProbe(): void {
    let isProbeRequest = false;
    try {
      const searchParams = new URLSearchParams(window && window.location ? window.location.search : '');
      isProbeRequest = searchParams.get('vs_budget_probe') === '1';
    } catch (error) {
      isProbeRequest = false;
    }

    if (!isProbeRequest) {
      return;
    }

    const currentUser = this.authenticationService.currentUserValue;
    const hasSession = !!(currentUser && currentUser.user_id !== undefined && currentUser.user_id !== null && currentUser.token);
    const env = localStorage.getItem('enviroment') ? localStorage.getItem('enviroment').toString() : '';

    try {
      if (window && window.opener && !window.opener.closed) {
        window.opener.postMessage({
          channel: 'vs_cut_session_probe',
          has_session: hasSession,
          env: env
        }, '*');
      }
    } catch (error) {}

    setTimeout(() => {
      try {
        window.close();
      } catch (error) {}
    }, 60);
  }

  ngOnDestroy() {
    console.log('--> --> Destruyendo componente APP...');
    // NOTA: De este modo desactivamos todas las subscripciones del componente principal.
    this.componentActive = false;
    this.stopOptimizationVisualLoop();
    this.stopAutoExecOverlayLoop();
    this.stopOptimizerQueueLoop();
    this.unregisterOptimizerQueueEvents();
  }

  registerOptimizerQueueEvents() {
    if (this.optimizerQueueEventHandler) {
      return;
    }
    this.optimizerQueueEventHandler = () => {
      this.pollOptimizerQueue();
    };
    window.addEventListener('vs_backend_optimizer_job_started', this.optimizerQueueEventHandler);
  }

  unregisterOptimizerQueueEvents() {
    if (!this.optimizerQueueEventHandler) {
      return;
    }
    window.removeEventListener('vs_backend_optimizer_job_started', this.optimizerQueueEventHandler);
    this.optimizerQueueEventHandler = null;
  }

  startOptimizerQueueLoop() {
    this.optimizerQueueClockMs = Date.now();
    this.pollOptimizerQueue();
    if (this.optimizerQueueTimer) {
      return;
    }
    this.optimizerQueueTimer = setInterval(() => {
      this.optimizerQueueClockMs = Date.now();
      this.pollOptimizerQueue();
    }, this.optimizerQueueModal ? 8000 : 15000);
  }

  stopOptimizerQueueLoop() {
    if (this.optimizerQueueTimer) {
      clearInterval(this.optimizerQueueTimer);
      this.optimizerQueueTimer = null;
    }
  }

  pollOptimizerQueue() {
    this.optimizerQueueClockMs = Date.now();
    if (!this.currentUser || this.optimizerQueuePolling) {
      return;
    }

    this.optimizerQueuePolling = true;
    this.optiService.getOptimizerBenchmarkQueue().subscribe(
      data => {
        this.optimizerQueuePolling = false;
        if (!data) {
          return;
        }
        const jobs = Array.isArray(data) ? data : (Array.isArray(data.jobs) ? data.jobs : []);
        this.optimizerQueueJobs = jobs;
        this.optimizerQueueLastPollAt = new Date();
        this.optimizerQueueActiveCount = jobs.filter(job => this.isOptimizerJobActive(job)).length;
        this.optimizerQueueHasAttention = this.hasOptimizerQueueAttention(jobs);
        if (this.optimizerQueueSelectedJob && this.optimizerQueueSelectedJob.id) {
          const selectedSummary = jobs.find(job => job && job.id === this.optimizerQueueSelectedJob.id);
          if (selectedSummary) {
            const previousSelectedJob = this.optimizerQueueSelectedJob;
            this.optimizerQueueSelectedJob = Object.assign({}, previousSelectedJob, selectedSummary);
            if (this.hasFullOptimizerJobResults(previousSelectedJob) && !this.hasFullOptimizerJobResults(selectedSummary)) {
              this.optimizerQueueSelectedJob.results = previousSelectedJob.results;
            }
            if (this.optimizerQueueResultModal && this.isOptimizerJobActive(selectedSummary)) {
              this.loadOptimizerQueueJobDetails(selectedSummary.id);
            }
            if (!this.isOptimizerJobActive(selectedSummary) && !this.hasFullOptimizerJobResults(this.optimizerQueueSelectedJob)) {
              this.loadOptimizerQueueJobDetails(selectedSummary.id);
            }
          }
        }
        if (this.optimizerStopPendingJobId) {
          const stoppedSummary = jobs.find(job => job && job.id === this.optimizerStopPendingJobId);
          if (stoppedSummary) {
            this.optimizerQueueSelectedJob = Object.assign(
              {},
              this.optimizerQueueSelectedJob && this.optimizerQueueSelectedJob.id === stoppedSummary.id
                ? this.optimizerQueueSelectedJob
                : {},
              stoppedSummary
            );
            this.optimizerQueueResultModal = true;
            if (!this.isOptimizerJobActive(stoppedSummary)) {
              const stoppedJobId = this.optimizerStopPendingJobId;
              this.optimizerStopPendingJobId = '';
              this.optimizerQueueShowDiscarded = false;
              this.loadOptimizerQueueJobDetails(stoppedJobId);
            }
          }
        }
        if (this.optimizerQueueModal && this.optimizerQueueHasAttention) {
          this.markOptimizerQueueSeen();
        }
        try {
          this.cdRef.detectChanges();
        } catch (changeError) {}
      },
      error => {
        this.optimizerQueuePolling = false;
        try {
          this.cdRef.detectChanges();
        } catch (changeError) {}
      }
    );
  }

  showOptimizerQueueModal(value: boolean) {
    this.optimizerQueueModal = value;
    this.stopOptimizerQueueLoop();
    this.startOptimizerQueueLoop();
    if (value) {
      this.optimizerQueueFilter = 'active';
      this.markOptimizerQueueSeen();
      this.pollOptimizerQueue();
    }
  }

  setOptimizerQueueFilter(filterIn: string) {
    this.optimizerQueueFilter = filterIn === 'all' ? 'all' : 'active';
  }

  getOptimizerQueueDisplayedJobs(): any[] {
    const jobs = Array.isArray(this.optimizerQueueJobs) ? this.optimizerQueueJobs : [];
    if (this.optimizerQueueFilter === 'all') {
      return jobs;
    }
    return jobs.filter(job => this.isOptimizerJobActive(job));
  }

  markOptimizerQueueSeen() {
    const seen = this.safeParseJsonArray(localStorage.getItem('vs_backend_optimizer_seen_jobs'));
    const seenMap = {};
    seen.forEach(item => {
      if (item) {
        seenMap[item] = true;
      }
    });

    this.optimizerQueueJobs.forEach(job => {
      if (job && job.requires_attention && job.id) {
        seenMap[job.id] = true;
      }
    });

    localStorage.setItem('vs_backend_optimizer_seen_jobs', JSON.stringify(Object.keys(seenMap).slice(-200)));
    this.optimizerQueueHasAttention = false;
  }

  hasOptimizerQueueAttention(jobsIn: any[]): boolean {
    const seen = this.safeParseJsonArray(localStorage.getItem('vs_backend_optimizer_seen_jobs'));
    const seenMap = {};
    seen.forEach(item => {
      if (item) {
        seenMap[item] = true;
      }
    });

    return jobsIn.some(job => job && job.requires_attention && job.id && !seenMap[job.id]);
  }

  isOptimizerJobActive(jobIn: any): boolean {
    return jobIn && (jobIn.status === 'queued' || jobIn.status === 'running');
  }

  isOptimizerJobStopRequested(jobIn: any): boolean {
    return !!(jobIn && jobIn.cancel_requested === true);
  }

  getOptimizerJobUsableResultCount(jobIn: any): number {
    if (!jobIn || !Array.isArray(jobIn.results)) {
      return 0;
    }
    return jobIn.results.filter(result =>
      result &&
      (!result.status || result.status === 'complete') &&
      Number(result.unplaced_pieces || 0) <= 0 &&
      Number(result.sheets || 0) > 0
    ).length;
  }

  getOptimizerJobProcessedVariantCount(jobIn: any): number {
    if (!jobIn) {
      return 0;
    }
    const explicit = Number(jobIn.processed_variants);
    if (Number.isFinite(explicit) && explicit >= 0) {
      return Math.round(explicit);
    }
    const completed = Number(jobIn.progress && jobIn.progress.completed);
    return Number.isFinite(completed) && completed >= 0 ? Math.round(completed) : 0;
  }

  showOptimizerStopModal(jobIn: any) {
    if (!jobIn || !jobIn.id || !this.isOptimizerJobActive(jobIn)) {
      return;
    }
    if (this.isOptimizerJobStopRequested(jobIn)) {
      return;
    }
    this.optimizerStopJob = this.optimizerQueueSelectedJob &&
      this.optimizerQueueSelectedJob.id === jobIn.id
      ? this.optimizerQueueSelectedJob
      : jobIn;
    this.optimizerStopSubmitting = false;
    this.optimizerStopModal = true;
  }

  closeOptimizerStopModal() {
    if (this.optimizerStopSubmitting) {
      return;
    }
    this.optimizerStopModal = false;
    this.optimizerStopJob = null;
  }

  confirmStopOptimizerJob() {
    const jobIn = this.optimizerStopJob;
    if (!jobIn || !jobIn.id || !this.isOptimizerJobActive(jobIn) || this.optimizerStopSubmitting) {
      return;
    }

    this.optimizerStopSubmitting = true;
    this.optiService.cancelOptimizerBenchmark({
      job_id: jobIn.id,
      keep_results: true
    }).subscribe(
      data => {
        this.optimizerStopSubmitting = false;
        this.optimizerStopModal = false;
        this.optimizerStopJob = null;
        this.optimizerStopPendingJobId = jobIn.id;
        this.optimizerQueueSelectedJob = data && data.id === jobIn.id
          ? data
          : jobIn;
        this.optimizerQueueResultModal = true;
        this.pollOptimizerQueue();
        setTimeout(() => this.pollOptimizerQueue(), 1000);
      },
      error => {
        this.optimizerStopSubmitting = false;
      }
    );
  }

  clearFinishedOptimizerJobs() {
    if (this.optimizerQueueClearing) {
      return;
    }
    const finishedCount = (this.optimizerQueueJobs || []).filter(job =>
      job && (job.status === 'complete' || job.status === 'error' || job.status === 'cancelled')
    ).length;
    if (finishedCount < 1) {
      return;
    }
    if (!window.confirm('Se eliminarán los trabajos finalizados, cancelados o con error de la cola. Los trabajos activos se conservarán.')) {
      return;
    }
    this.optimizerQueueClearing = true;
    this.optiService.clearOptimizerBenchmarkQueue('finished').subscribe(
      data => {
        this.optimizerQueueClearing = false;
        this.resetOptimizerQueueSelection();
        this.pollOptimizerQueue();
      },
      error => {
        this.optimizerQueueClearing = false;
      }
    );
  }

  resetOptimizerQueueSelection() {
    this.optimizerQueueSelectedJob = null;
    this.optimizerQueueResultModal = false;
    this.optimizerQueueCanvasModal = false;
    this.optimizerQueueCanvasResult = null;
    this.optimizerQueuePreviewLoadingKey = '';
    this.optimizerQueuePreviewLoadingMessage = '';
  }

  getOptimizerJobProgress(jobIn: any): number {
    if (jobIn && jobIn.status === 'complete') {
      return 100;
    }
    if (!jobIn || !jobIn.progress || !jobIn.progress.total) {
      return 0;
    }

    const current = Number(jobIn.progress.current);
    const total = Number(jobIn.progress.total);
    if (!Number.isFinite(current) || !Number.isFinite(total) || total <= 0) {
      return 0;
    }

    const completedRaw = Number(jobIn.progress.completed);
    let completed = Number.isFinite(completedRaw)
      ? completedRaw
      : current;
    let progressUnits = completed;
    if (jobIn.progress.phase === 'running_variant') {
      if (!Number.isFinite(completedRaw)) {
        completed = Math.max(0, current - 1);
        progressUnits = completed;
      }
      const variantStartedAt = Date.parse(jobIn.progress.variant_started_at || '');
      const expectedMs = Number(jobIn.progress.variant_expected_ms);
      if (
        Number.isFinite(variantStartedAt) &&
        variantStartedAt > 0 &&
        Number.isFinite(expectedMs) &&
        expectedMs > 0
      ) {
        const elapsedFraction = Math.max(0, this.optimizerQueueClockMs - variantStartedAt) / expectedMs;
        progressUnits += Math.min(0.9, elapsedFraction);
      }
    }

    const percent = Math.round((progressUnits * 100) / total);
    return Math.max(0, Math.min(99, percent));
  }

  getOptimizerJobProgressDetail(jobIn: any): string {
    if (!jobIn || !jobIn.progress) {
      return '';
    }
    const progress = jobIn.progress;
    const total = Number(progress.total);
    if (!Number.isFinite(total) || total <= 0) {
      return '';
    }

    const current = Number(progress.current);
    const completedRaw = Number(progress.completed);
    const completed = Number.isFinite(completedRaw)
      ? completedRaw
      : (progress.phase === 'running_variant' ? Math.max(0, current - 1) : current);
    if (progress.phase !== 'running_variant') {
      return Number.isFinite(completed)
        ? 'Completadas ' + completed + '/' + total
        : '';
    }

    const variant = Number(progress.current_variant || current);
    const variantStartedAt = Date.parse(progress.variant_started_at || '');
    const elapsedSeconds = Number.isFinite(variantStartedAt) && variantStartedAt > 0
      ? Math.max(0, Math.floor((this.optimizerQueueClockMs - variantStartedAt) / 1000))
      : 0;
    return 'Completadas ' + Math.max(0, completed) + '/' + total +
      ' · variante ' + (Number.isFinite(variant) ? variant : '?') + '/' + total +
      ' en curso · ' + this.formatElapsed(elapsedSeconds);
  }

  getOptimizerJobDurationSeconds(jobIn: any): number {
    if (!jobIn) {
      return 0;
    }
    const elapsedMs = Number(jobIn.elapsed_ms || jobIn.duration_ms);
    if (Number.isFinite(elapsedMs) && elapsedMs > 0) {
      return Math.max(0, Math.floor(elapsedMs / 1000));
    }
    const startedAt = Date.parse(jobIn.started_at || jobIn.created_at || '');
    if (!Number.isFinite(startedAt) || startedAt <= 0) {
      return 0;
    }
    const finishedAt = Date.parse(jobIn.finished_at || '');
    const endAt = Number.isFinite(finishedAt) && finishedAt > 0
      ? finishedAt
      : this.optimizerQueueClockMs;
    return Math.max(0, Math.floor((endAt - startedAt) / 1000));
  }

  getOptimizerJobDurationText(jobIn: any): string {
    const seconds = this.getOptimizerJobDurationSeconds(jobIn);
    if (seconds <= 0) {
      return '-';
    }
    return this.formatElapsed(seconds);
  }

  getOptimizerResultElapsedText(resultIn: any): string {
    if (!resultIn) {
      return '-';
    }
    const elapsedMs = Number(resultIn.elapsed_ms);
    if (!Number.isFinite(elapsedMs) || elapsedMs <= 0) {
      return '-';
    }
    return this.formatElapsed(Math.floor(elapsedMs / 1000));
  }

  getOptimizerResultFinalRetalText(resultIn: any): string {
    if (!resultIn) {
      return '-';
    }
    const snapshotMetrics = resultIn.layout_snapshot && resultIn.layout_snapshot.metrics
      ? resultIn.layout_snapshot.metrics
      : {};
    const width = Number(
      resultIn.final_retal_width_mm !== undefined
        ? resultIn.final_retal_width_mm
        : (resultIn.max_retal_width_mm !== undefined
          ? resultIn.max_retal_width_mm
          : snapshotMetrics.max_retal_width_mm)
    );
    const height = Number(
      resultIn.final_retal_height_mm !== undefined
        ? resultIn.final_retal_height_mm
        : (resultIn.max_retal_height_mm !== undefined
          ? resultIn.max_retal_height_mm
          : snapshotMetrics.max_retal_height_mm)
    );
    const area = Number(
      resultIn.final_retal_area_m2 !== undefined
        ? resultIn.final_retal_area_m2
        : (resultIn.max_retal_area_m2 !== undefined
          ? resultIn.max_retal_area_m2
          : snapshotMetrics.max_retal_area)
    );
    const formatDimension = (valueIn: number): string => {
      return Math.abs(valueIn - Math.round(valueIn)) < 0.01
        ? Math.round(valueIn).toString()
        : valueIn.toFixed(1);
    };

    if (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) {
      const dimensions = formatDimension(width) + ' × ' + formatDimension(height) + ' mm';
      return Number.isFinite(area) && area > 0
        ? dimensions + ' · ' + area.toFixed(2) + ' m²'
        : dimensions;
    }
    return Number.isFinite(area) && area > 0 ? area.toFixed(2) + ' m²' : '-';
  }

  getOptimizerResultLayoutLabel(resultIn: any): string {
    if (!resultIn || !resultIn.strategy) {
      return '';
    }
    const strategy = resultIn.strategy.toString();
    if (strategy.indexOf('packstrip_mix_layered_rows') < 0) {
      return '';
    }
    const suffixParts = [];
    if (strategy.indexOf('reserve') >= 0 || (resultIn.packstrip_profile || '').toString().indexOf('reserve') >= 0) {
      suffixParts.push('reserva anclas');
    }
    if (strategy.indexOf('fine_fill') >= 0 || (resultIn.packstrip_profile || '').toString().indexOf('fine_fill') >= 0) {
      suffixParts.push('selección fina');
    }
    if (resultIn.local_compact_applied === true && Number(resultIn.local_compact_emptied_sheets || 0) > 0) {
      suffixParts.push('pulido local');
    } else if (resultIn.local_compact_applied === true && Number(resultIn.local_compact_moved || 0) > 0) {
      suffixParts.push('filas compactadas');
    }
    if (Number(resultIn.local_gap_reuse_moved || 0) > 0) {
      suffixParts.push('reaprovecha huecos');
    }
    const suffix = suffixParts.length > 0 ? ' + ' + suffixParts.join(' + ') : '';
    if (strategy.indexOf('nodirect') >= 0 || resultIn.packstrip_direct_layout === false) {
      return 'Orden guiado' + suffix;
    }
    return resultIn.strip_family_direct_applied === true ? 'Subtraveras libres' + suffix : 'Subtraveras libres no aplicada' + suffix;
  }

  getOptimizerPreviewLoadingKey(resultIndexIn: number): string {
    const jobId = this.optimizerQueueSelectedJob && this.optimizerQueueSelectedJob.id ? this.optimizerQueueSelectedJob.id : '';
    return jobId + ':' + resultIndexIn;
  }

  isOptimizerPreviewLoading(resultIndexIn: number): boolean {
    return !!(this.optimizerQueuePreviewLoadingKey && this.optimizerQueuePreviewLoadingKey === this.getOptimizerPreviewLoadingKey(resultIndexIn));
  }

  getOptimizerJobStatusLabel(jobIn: any): string {
    if (!jobIn) {
      return '-';
    }
    if (this.isOptimizerJobActive(jobIn) && this.isOptimizerJobStopRequested(jobIn)) {
      return 'Deteniendo...';
    }
    if (jobIn.status === 'queued') {
      return 'En cola';
    }
    if (jobIn.status === 'running') {
      return 'Ejecutando';
    }
    if (jobIn.status === 'complete') {
      return 'Terminada';
    }
    if (jobIn.status === 'cancelled') {
      return jobIn.stop_mode === 'keep_results'
        ? 'Detenida por el usuario'
        : 'Cancelada';
    }
    if (jobIn.status === 'error') {
      return 'Error';
    }
    return jobIn.status;
  }

  getOptimizerJobStatusClass(jobIn: any): string {
    if (!jobIn) {
      return 'is-light';
    }
    if (this.isOptimizerJobActive(jobIn) && this.isOptimizerJobStopRequested(jobIn)) {
      return 'is-warning';
    }
    if (jobIn.status === 'complete') {
      return 'is-success';
    }
    if (jobIn.status === 'running') {
      return 'is-info';
    }
    if (jobIn.status === 'queued') {
      return 'is-warning';
    }
    if (jobIn.status === 'cancelled' && jobIn.stop_mode === 'keep_results') {
      return 'is-warning';
    }
    if (jobIn.status === 'error') {
      return 'is-danger';
    }
    return 'is-light';
  }

  getOptimizerJobBestResult(jobIn: any): any {
    const candidates = this.getOptimizerJobRecommendedResults(jobIn);
    return candidates.find(result =>
      result &&
      Array.isArray(result.result_badges) &&
      result.result_badges.some(badge => badge && badge.key === 'best_balance')
    ) || candidates[0] || null;
  }

  hasOptimizerJobResults(jobIn: any): boolean {
    return !!(jobIn && Array.isArray(jobIn.results) && jobIn.results.length > 0);
  }

  hasFullOptimizerJobResults(jobIn: any): boolean {
    return !!(
      jobIn &&
      Array.isArray(jobIn.results) &&
      jobIn.results.some(result => result && result.layout_snapshot && Array.isArray(result.layout_snapshot.total_graphic_list))
    );
  }

  getOptimizerJobDisplayResults(jobIn: any): any[] {
    if (!this.hasOptimizerJobResults(jobIn)) {
      return [];
    }
    const indexedResults = jobIn.results.map((result, index) =>
      Object.assign({}, result || {}, { __optimizer_result_index: index })
    );
    const frontendResults = indexedResults.filter(result => {
      return result && result.strategy && result.strategy.toString().indexOf('frontend_mirror') === 0;
    });
    const sourceResults = frontendResults.length > 0 ? frontendResults : indexedResults;
    return classifyOptimizationResults(sourceResults);
  }

  getOptimizerJobRecommendedResults(jobIn: any): any[] {
    const classified = this.getOptimizerJobDisplayResults(jobIn);
    const recommended = classified.filter(result =>
      result && result.industrial_recommended === true
    );
    return recommended.length > 0
      ? recommended
      : classified.filter(result => result && result.industrial_discarded !== true);
  }

  getOptimizerJobIndustrialAlternatives(jobIn: any): any[] {
    return this.getOptimizerJobDisplayResults(jobIn).filter(result =>
      result && result.industrial_pareto_alternative === true
    ).sort((left, right) => {
      const sheetDiff = Number(left.sheets) - Number(right.sheets);
      if (sheetDiff !== 0) {
        return sheetDiff;
      }
      const stackDiff = Number(left.stacks) - Number(right.stacks);
      if (stackDiff !== 0) {
        return stackDiff;
      }
      return Number(left.waste_percent) - Number(right.waste_percent);
    }).slice(0, 3);
  }

  getOptimizerJobPrimaryResults(jobIn: any): any[] {
    return this.getOptimizerJobRecommendedResults(jobIn)
      .concat(this.getOptimizerJobIndustrialAlternatives(jobIn));
  }

  getOptimizerJobDiscardedResults(jobIn: any): any[] {
    return this.getOptimizerJobDisplayResults(jobIn).filter(result =>
      result &&
      result.industrial_discarded === true &&
      result.industrial_pareto_alternative !== true
    );
  }

  toggleOptimizerQueueDiscarded(): void {
    this.optimizerQueueShowDiscarded = !this.optimizerQueueShowDiscarded;
  }

  showOptimizerQueueResults(jobIn: any) {
    if (!jobIn || !jobIn.id) {
      return;
    }
    this.optimizerQueueSelectedJob = jobIn;
    this.optimizerQueueResultModal = true;
    this.optimizerQueueShowDiscarded = false;
    this.loadOptimizerQueueJobDetails(jobIn.id);
  }

  loadOptimizerQueueJobDetails(jobIdIn: string) {
    if (!jobIdIn) {
      return;
    }
    this.optiService.getOptimizerBenchmark({ job_id: jobIdIn }).subscribe(
      data => {
        if (data && data.id === jobIdIn) {
          this.optimizerQueueSelectedJob = data;
        }
      },
      error => {}
    );
  }

  closeOptimizerQueueResults() {
    this.optimizerQueueResultModal = false;
    this.optimizerQueueSelectedJob = null;
    this.optimizerQueuePreviewLoadingKey = '';
    this.optimizerQueuePreviewLoadingMessage = '';
    this.optimizerQueueShowDiscarded = false;
    this.optimizerStopModal = false;
    this.optimizerStopJob = null;
    this.optimizerStopSubmitting = false;
  }

  loadOptimizerQueueResultSnapshot(resultIndexIn: number, callbackIn: (result: any) => void) {
    const job = this.optimizerQueueSelectedJob;
    if (!job || !job.id || resultIndexIn === null || resultIndexIn === undefined || resultIndexIn < 0) {
      return;
    }
    this.optiService.getOptimizerBenchmark({ job_id: job.id, full: true, result_index: resultIndexIn }).subscribe(
      data => {
        if (!data || !Array.isArray(data.results) || !data.results[resultIndexIn]) {
          callbackIn(null);
          return;
        }
        this.optimizerQueueSelectedJob = data;
        const result = data.results[resultIndexIn];
        if (!this.hasOptimizerQueueCanvas(result) && result && result.layout_snapshot) {
          result.layout_snapshot.available = false;
          result.layout_snapshot.error = true;
        }
        callbackIn(result);
      },
      error => {
        this.optimizerQueuePreviewLoadingKey = '';
        this.optimizerQueuePreviewLoadingMessage = '';
        callbackIn(null);
      }
    );
  }

  showOptimizerQueueCanvas(resultIn: any, resultIndexIn?: number) {
    if (this.hasOptimizerQueueCanvas(resultIn)) {
      this.optimizerQueueCanvasResult = resultIn;
      this.optimizerQueueCanvasModal = true;
      return;
    }
    if (!this.hasOptimizerQueueCanvasAvailable(resultIn)) {
      return;
    }
    this.optimizerQueuePreviewLoadingKey = this.getOptimizerPreviewLoadingKey(resultIndexIn);
    this.optimizerQueuePreviewLoadingMessage = 'Preparando previsualización del resultado seleccionado...';
    this.loadOptimizerQueueResultSnapshot(resultIndexIn, result => {
      this.optimizerQueuePreviewLoadingKey = '';
      this.optimizerQueuePreviewLoadingMessage = '';
      if (result && this.hasOptimizerQueueCanvas(result)) {
        this.optimizerQueueCanvasResult = result;
        this.optimizerQueueCanvasModal = true;
      }
    });
  }

  finalizeOptimizerQueueResult(resultIn: any, resultIndexIn?: number) {
    if (!this.hasOptimizerQueueCanvas(resultIn)) {
      if (this.hasOptimizerQueueCanvasAvailable(resultIn)) {
        this.optimizerQueuePreviewLoadingKey = this.getOptimizerPreviewLoadingKey(resultIndexIn);
        this.optimizerQueuePreviewLoadingMessage = 'Preparando resultado para finalizar...';
        this.loadOptimizerQueueResultSnapshot(resultIndexIn, result => {
          this.optimizerQueuePreviewLoadingKey = '';
          this.optimizerQueuePreviewLoadingMessage = '';
          if (result && this.hasOptimizerQueueCanvas(result)) {
            if (resultIn && resultIn.industrial_discarded === true) {
              result.industrial_discarded = true;
              result.industrial_discard_reason = resultIn.industrial_discard_reason;
              result.industrial_extra_sheets = resultIn.industrial_extra_sheets;
            }
            this.finalizeOptimizerQueueResult(result, resultIndexIn);
          }
        });
      }
      return;
    }
    if (
      resultIn &&
      resultIn.industrial_discarded === true &&
      !window.confirm(
        'Esta alternativa está descartada por consumo: ' +
        (resultIn.industrial_discard_reason || 'utiliza más hojas que las opciones recomendadas.') +
        '\n\n¿Quieres utilizarla de todos modos?'
      )
    ) {
      return;
    }

    const selectedJob = this.optimizerQueueSelectedJob;
    const dispatchResult = () => {
      try {
        window.dispatchEvent(new CustomEvent('vs_backend_optimizer_apply_result', {
          detail: {
            result: resultIn,
            job: selectedJob
          }
        }));
      } catch (error) {}
    };

    const job = selectedJob;
    const currentUrl = this.router && this.router.url ? this.router.url.toString() : '';
    if (currentUrl.indexOf('/file-list') !== 0 && job && job.opti_id) {
      this.router.navigate(['/file-list', job.opti_id]).then(() => {
        setTimeout(() => {
          dispatchResult();
        }, 900);
      });
    } else {
      dispatchResult();
    }

    this.closeOptimizerQueueCanvas();
    this.closeOptimizerQueueResults();
    this.showOptimizerQueueModal(false);
  }

  closeOptimizerQueueCanvas() {
    this.optimizerQueueCanvasModal = false;
    this.optimizerQueueCanvasResult = null;
    this.optimizerQueuePreviewLoadingKey = '';
    this.optimizerQueuePreviewLoadingMessage = '';
  }

  getOptimizerQueueResultSource(resultIn: any): string {
    if (!resultIn) {
      return '-';
    }
    if (resultIn.algorithm_version) {
      return resultIn.algorithm_version;
    }
    if (resultIn.algorithm_source) {
      return resultIn.algorithm_source;
    }
    return resultIn.strategy || '-';
  }

  hasOptimizerQueueCanvas(resultIn: any): boolean {
    return !!(
      resultIn &&
      resultIn.layout_snapshot &&
      Array.isArray(resultIn.layout_snapshot.total_graphic_list) &&
      resultIn.layout_snapshot.total_graphic_list.length > 0
    );
  }

  hasOptimizerQueueCanvasAvailable(resultIn: any): boolean {
    return !!(
      resultIn &&
      resultIn.layout_snapshot &&
      (
        (Array.isArray(resultIn.layout_snapshot.total_graphic_list) && resultIn.layout_snapshot.total_graphic_list.length > 0) ||
        resultIn.layout_snapshot.available === true
      )
    );
  }

  getOptimizerCanvasSheets(): any[] {
    if (!this.hasOptimizerQueueCanvas(this.optimizerQueueCanvasResult)) {
      return [];
    }
    return this.optimizerQueueCanvasResult.layout_snapshot.total_graphic_list;
  }

  getOptimizerCanvasSheetItem(sheetGraphicsIn: any[]): any {
    if (!Array.isArray(sheetGraphicsIn)) {
      return null;
    }
    return sheetGraphicsIn.find(item => item && item.type === 'S') || null;
  }

  getOptimizerCanvasItems(sheetGraphicsIn: any[]): any[] {
    if (!Array.isArray(sheetGraphicsIn)) {
      return [];
    }
    return sheetGraphicsIn
      .filter(item => item && item.type !== 'S' && Array.isArray(item.points) && item.points.length > 0)
      .slice()
      .sort((a, b) => {
        const aPiece = a && a.type === 'P' ? 1 : 0;
        const bPiece = b && b.type === 'P' ? 1 : 0;
        if (aPiece !== bPiece) {
          return aPiece - bPiece;
        }
        return 0;
      });
  }

  getOptimizerCanvasViewBox(sheetGraphicsIn: any[]): string {
    const sheet = this.getOptimizerCanvasSheetItem(sheetGraphicsIn);
    const width = Number(sheet && sheet.width ? sheet.width : 6000);
    const height = Number(sheet && sheet.height ? sheet.height : 3210);
    return '0 0 ' + width + ' ' + height;
  }

  getOptimizerCanvasAspect(sheetGraphicsIn: any[]): string {
    const sheet = this.getOptimizerCanvasSheetItem(sheetGraphicsIn);
    const width = Number(sheet && sheet.width ? sheet.width : 6000);
    const height = Number(sheet && sheet.height ? sheet.height : 3210);
    return width + ' / ' + height;
  }

  getOptimizerCanvasPoints(itemIn: any): string {
    if (!itemIn || !Array.isArray(itemIn.points)) {
      return '';
    }
    return itemIn.points.map(pt => Number(pt.x || 0) + ',' + Number(pt.y || 0)).join(' ');
  }

  getOptimizerCanvasFill(itemIn: any): string {
    if (!itemIn) {
      return '#e5e7eb';
    }
    if (itemIn.type === 'P') {
      return '#a7d8ff';
    }
    if (itemIn.type === 'R') {
      return '#b7c0cc';
    }
    if (itemIn.type === 'T') {
      return '#e5e7eb';
    }
    return '#f3f4f6';
  }

  getOptimizerCanvasStroke(itemIn: any): string {
    if (itemIn && itemIn.type === 'P') {
      return '#1d4ed8';
    }
    if (itemIn && itemIn.type === 'R') {
      return '#4b5563';
    }
    if (itemIn && itemIn.type === 'T') {
      return '#9ca3af';
    }
    return '#6b7280';
  }

  getOptimizerCanvasLabelText(itemIn: any): string {
    if (!itemIn) {
      return '';
    }
    const value = itemIn.name !== undefined && itemIn.name !== null && itemIn.name !== ''
      ? itemIn.name
      : itemIn.num;
    return value !== undefined && value !== null ? value.toString() : '';
  }

  getOptimizerCanvasLabelFontSize(itemIn: any): number {
    if (!itemIn || !Array.isArray(itemIn.points) || itemIn.points.length < 1) {
      return 0;
    }
    const text = this.getOptimizerCanvasLabelText(itemIn);
    if (!text) {
      return 0;
    }
    const xs = itemIn.points.map(pt => Number(pt.x || 0));
    const ys = itemIn.points.map(pt => Number(pt.y || 0));
    const width = Math.max.apply(null, xs) - Math.min.apply(null, xs);
    const height = Math.max.apply(null, ys) - Math.min.apply(null, ys);
    const byWidth = width / Math.max(1, text.length * 0.62);
    const byHeight = height * 0.42;
    return Math.max(0, Math.floor(Math.min(150, byWidth, byHeight)));
  }

  getOptimizerCanvasLabelX(itemIn: any): number {
    if (!itemIn || !Array.isArray(itemIn.points) || itemIn.points.length < 1) {
      return 0;
    }
    const xs = itemIn.points.map(pt => Number(pt.x || 0));
    return (Math.min.apply(null, xs) + Math.max.apply(null, xs)) / 2;
  }

  getOptimizerCanvasLabelY(itemIn: any): number {
    if (!itemIn || !Array.isArray(itemIn.points) || itemIn.points.length < 1) {
      return 0;
    }
    const ys = itemIn.points.map(pt => Number(pt.y || 0));
    return (Math.min.apply(null, ys) + Math.max.apply(null, ys)) / 2;
  }

  shouldShowOptimizerCanvasLabel(itemIn: any): boolean {
    return !!(itemIn && itemIn.type === 'P' && this.getOptimizerCanvasLabelFontSize(itemIn) >= 55);
  }

  startAutoExecOverlayLoop() {
    this.refreshAutoExecOverlayState();
    if (this.autoExecOverlayTimer) {
      return;
    }
    this.autoExecOverlayTimer = setInterval(() => {
      this.autoExecOverlayPulse = (this.autoExecOverlayPulse + 1) % 4;
      this.refreshAutoExecOverlayState();
    }, 500);
  }

  stopAutoExecOverlayLoop() {
    if (this.autoExecOverlayTimer) {
      clearInterval(this.autoExecOverlayTimer);
      this.autoExecOverlayTimer = null;
    }
    this.autoExecOverlayVisible = false;
  }

  refreshAutoExecOverlayState() {
    const continueFlag = localStorage.getItem('vs_auto_batch_continue') === '1';
    const queue = this.safeParseJsonArray(localStorage.getItem('vs_auto_batch_queue'));
    const total = queue.length;

    if (!continueFlag || total < 1) {
      this.autoExecOverlayVisible = false;
      this.autoExecOverlayCurrentMaterial = '';
      this.autoExecOverlayCompleted = 0;
      this.autoExecOverlayTotal = 0;
      this.autoExecOverlayPending = 0;
      this.autoExecOverlayPercent = 0;
      this.autoExecOverlayCurrentStep = 0;
      this.autoExecOverlayElapsedText = '00:00';
      this.autoExecOverlayHeartbeatText = '-';
      this.autoExecOverlayStalled = false;
      return;
    }

    const indexRaw = localStorage.getItem('vs_auto_batch_index');
    let completed = indexRaw ? Number(indexRaw) : 0;
    if (isNaN(completed) || completed < 0) {
      completed = 0;
    }
    if (completed > total) {
      completed = total;
    }

    const currentJob = this.safeParseJsonObject(localStorage.getItem('vs_auto_batch_current_job'));
    const expectedJob = completed < total ? queue[completed] : null;
    const job = currentJob ? currentJob : expectedJob;

    this.autoExecOverlayVisible = true;
    this.autoExecOverlayCompleted = completed;
    this.autoExecOverlayTotal = total;
    this.autoExecOverlayPending = Math.max(total - completed, 0);
    this.autoExecOverlayPercent = total > 0 ? Math.min(Math.round((completed * 100) / total), 100) : 0;
    this.autoExecOverlayCurrentStep = completed < total ? (completed + 1) : total;
    this.autoExecOverlayCurrentMaterial = this.formatAutoExecMaterialLabel(job);

    const jobStartRaw = localStorage.getItem('vs_auto_batch_job_started_at');
    const jobStartTs = jobStartRaw ? Number(jobStartRaw) : 0;
    const elapsedSec = jobStartTs > 0 ? Math.max(0, Math.floor((Date.now() - jobStartTs) / 1000)) : 0;
    this.autoExecOverlayElapsedText = this.formatAutoExecTime(elapsedSec);

    let localAgeSec = -1;
    const localHbRaw = localStorage.getItem('vs_auto_batch_local_hb');
    if (localHbRaw) {
      try {
        const localHb = JSON.parse(localHbRaw);
        if (localHb && localHb.ts) {
          localAgeSec = Math.max(0, Math.floor((Date.now() - Number(localHb.ts)) / 1000));
        }
      } catch (e) {}
    }
    let backendAgeSec = -1;
    const backendHbRaw = localStorage.getItem('vs_auto_batch_backend_hb');
    if (backendHbRaw) {
      try {
        const backendHb = JSON.parse(backendHbRaw);
        if (backendHb && backendHb.ts) {
          backendAgeSec = Math.max(0, Math.floor((Date.now() - Number(backendHb.ts)) / 1000));
        }
      } catch (e) {}
    }
    const candidateAges = [localAgeSec, backendAgeSec].filter(item => Number.isFinite(item) && item >= 0);
    const freshestAge = candidateAges.length > 0 ? Math.min(...candidateAges) : -1;
    this.autoExecOverlayHeartbeatText = this.formatAutoExecAge(freshestAge);
    this.autoExecOverlayStalled = Math.max(localAgeSec, backendAgeSec) >= 20;
  }

  formatAutoExecTime(totalSecondsIn: number): string {
    const secs = Number.isFinite(totalSecondsIn) && totalSecondsIn > 0 ? Math.floor(totalSecondsIn) : 0;
    const mm = Math.floor(secs / 60);
    const ss = secs % 60;
    return (mm < 10 ? ('0' + mm.toString()) : mm.toString()) + ':' + (ss < 10 ? ('0' + ss.toString()) : ss.toString());
  }

  formatAutoExecAge(secondsIn: number): string {
    if (!Number.isFinite(secondsIn) || secondsIn < 0) {
      return '-';
    }
    if (secondsIn < 60) {
      return secondsIn.toString() + 's';
    }
    const mm = Math.floor(secondsIn / 60);
    const ss = secondsIn % 60;
    return mm.toString() + 'm ' + (ss < 10 ? ('0' + ss.toString()) : ss.toString()) + 's';
  }

  getAutoExecPulseDots(): string {
    return '.'.repeat((this.autoExecOverlayPulse % 4) + 1);
  }

  safeParseJsonArray(rawIn: any): any[] {
    if (!rawIn) {
      return [];
    }
    try {
      const parsed = JSON.parse(rawIn);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  safeParseJsonObject(rawIn: any): any {
    if (!rawIn) {
      return null;
    }
    try {
      const parsed = JSON.parse(rawIn);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  formatAutoExecMaterialLabel(jobIn: any): string {
    if (!jobIn) {
      return 'Preparando material...';
    }
    const materialId = jobIn.materialid !== undefined && jobIn.materialid !== null ? jobIn.materialid.toString() : '';
    const materialDesc = jobIn.materialdesc ? jobIn.materialdesc.toString() : '';
    if (materialId && materialDesc) {
      return materialId + ' - ' + materialDesc;
    }
    if (materialId) {
      return materialId;
    }
    if (materialDesc) {
      return materialDesc;
    }
    return 'Preparando material...';
  }

  updateOptimizationVisualState() {
    const shouldRun = this.loading5 || this.loading6;
    if (shouldRun && !this.optimizationVisualActive) {
      this.startOptimizationVisualLoop();
      return;
    }

    if (!shouldRun && this.optimizationVisualActive) {
      this.stopOptimizationVisualLoop();
    }
  }

  startOptimizationVisualLoop() {
    this.optimizationVisualActive = true;
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 1;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = Date.now();
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = this.getOptimizationSpeedLabel();
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    localStorage.setItem('vs_cut_cancel_optimization', '0');
    localStorage.setItem('vs_cut_progress_sheets', '0');

    if (this.optimizationVisualTimer) {
      clearInterval(this.optimizationVisualTimer);
      this.optimizationVisualTimer = null;
    }

    this.optimizationVisualTimer = setInterval(() => {
      this.optimizationVisualProgress += 4;
      if (this.optimizationVisualProgress > 100) {
        this.optimizationVisualProgress = 0;
        this.optimizationVisualIteration += 1;
      }

      // Contador visual dinámico de probaturas.
      this.optimizationVisualAttempts += (2 + Math.floor(Math.random() * 7));

      const elapsedSec = Math.floor((Date.now() - this.optimizationVisualStartTs) / 1000);
      this.optimizationVisualElapsedText = this.formatElapsed(elapsedSec);
      this.optimizationVisualSpeedLabel = this.getOptimizationSpeedLabel();

      const sheetsRaw = localStorage.getItem('vs_cut_progress_sheets');
      const sheetsVal = sheetsRaw ? Number(sheetsRaw) : 0;
      this.optimizationVisualSheets = isNaN(sheetsVal) ? 0 : sheetsVal;
    }, 110);
  }

  stopOptimizationVisualLoop() {
    this.optimizationVisualActive = false;
    if (this.optimizationVisualTimer) {
      clearInterval(this.optimizationVisualTimer);
      this.optimizationVisualTimer = null;
    }
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 0;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = 0;
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = '-';
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    localStorage.setItem('vs_cut_cancel_optimization', '0');
    localStorage.setItem('vs_cut_progress_sheets', '0');
  }

  formatElapsed(totalSecondsIn: number): string {
    const totalSeconds = totalSecondsIn > 0 ? totalSecondsIn : 0;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const mm = minutes < 10 ? ('0' + minutes) : minutes.toString();
    const ss = seconds < 10 ? ('0' + seconds) : seconds.toString();
    return mm + ':' + ss;
  }

  requestCancelOptimization() {
    this.optimizationCancelRequested = true;
    localStorage.setItem('vs_cut_cancel_optimization', '1');
  }

  getOptimizationSpeedLabel(): string {
    const speedRaw = localStorage.getItem('vs_cut_progress_speed');
    if (speedRaw === 'optimal') {
      return 'Óptima';
    }
    if (speedRaw === 'medium') {
      return 'Media';
    }
    if (speedRaw === 'fast') {
      return 'Rápida';
    }
    return '-';
  }

  // IMPORTANTE: Función que se dispara cuando se pulsa el botón de deslogueo del usuario.
  // Debe vaciar todas las variables REDUX que estén vinculadas al usuario que sale.
  logoutButtonClick() {
    this.authenticationService.logout();

    this.store.dispatch(new userActions.ClearUser());
    this.store.dispatch(new fileActions.InicializeFile());
    this.store.dispatch(new optiActions.InicializeOpti());
    this.store.dispatch(new cuttingTableActions.InicializeCuttingTable());
    this.store.dispatch(new easelActions.InicializeEasel());
    this.store.dispatch(new reasonActions.InicializeReason());
  }

  languageButtonClick() {

    console.log('-> Pulsado botón Cambiar Idioma');
    console.log(this.languageOption);

    this.trans.changeLanguage(this.languageOption);

    // Refrescar la misma página en la que estamos.
    //window.location.reload();

    // Ir a la página de inicio donde ya aparecerá todo en el idioma seleccionado.
    this.router.navigate(['./']);

  } // End function languageButtonClick
  
  // Test de Velocidad para el Optimizador
  // Basado en benchmarks de referencia (M3 Pro, A18 Pro, i3, M1)
  testSpeedButtonClick() {
    // console.log('--> Ejecutando función testSpeedButtonClick.');
    
    // Simulación de carga: Cálculo intensivo de 10 millones de iteraciones
    // Este bloque mide la velocidad bruta de ejecución de JavaScript
    let test_iteration = 3;
    let list_result = [];
    
    let control = 0;
    
    const inicio = performance.now();
    
    for (let i = 0; i < test_iteration; i++) {
		
		const inicio_aux = performance.now();
		
	    for (let j = 0; j < 10_000_000; j++) {
	        control += Math.sqrt(j) * Math.sin(j);
	    }
	    
	    const fin_aux = performance.now();
	    const duracionMs_aux = fin_aux - inicio_aux;
	    
	    list_result.push(duracionMs_aux);
	
	} // End For 3.
	
	console.log('-> list result: ');
	console.log(list_result);
	
	let total_time = 0;
	
	list_result.forEach(du => {
		total_time += du;
	});
	
	const fin = performance.now();
	
	const total_duracionMs = fin - inicio;
	
	const duracionMs = total_time / test_iteration;
	
	console.log('-> duracionMs duración media: ');
	console.log(duracionMs);
	
	console.log('-> total_duracionMs duración total: ');
	console.log(total_duracionMs);
	
    // Lógica de categorización basada en tus pruebas
    let diagnostico = '';
    let color = '';
	/*
    if (duracionMs < 40) {
        diagnostico = '<p class="has-background-success">Excelente:</p> Rendimiento nivel M3 Pro / A18 Pro.';
        color = "#28a745"; // Verde
    } else if (duracionMs < 80) {
        diagnostico = '<p class="has-background-info">Bueno:</p> Rendimiento nivel iMac / Escritorio.';
        color = "#ffc107"; // Amarillo/Dorado
    } else if (duracionMs < 150) {
        diagnostico = '<strong><p class="has-background-warning has-text-centered">Moderado</p></strong> <p class="has-text-centered">Posible limitación de batería o hardware antiguo.</p>';
        color = "#fd7e14"; // Naranja
    } else {
        diagnostico = '<p class="has-background-danger">Bajo:</p> El sistema operativo o el hardware están limitando la ejecución.';
        color = "#dc3545"; // Rojo
    } // */
    
    // -------------
    // NUEVA LÓGICA DE CATEGORIZACIÓN (Recalibrada)

	if (duracionMs < 100) {
	    // Tu M3 Pro con 87ms ahora entraría aquí holgadamente
	    diagnostico = '<strong><p class="has-background-success has-text-centered">Excelente:</p></strong><p class="has-text-centered">Tu hardware está optimizado para el máximo rendimiento.</p>';
	    color = "#28a745"; // Verde
	} else if (duracionMs < 180) {
	    diagnostico = '<strong><p class="has-background-info has-text-centered">Bueno:</p></strong><p class="has-text-centered">Rendimiento sólido para el optimizador.</p>';
	    color = "#82c91e"; // Verde lima
	} else if (duracionMs < 300) {
	    diagnostico = '<strong><p class="has-background-warning has-text-centered">Moderado</p></strong><p class="has-text-centered">El rendimiento es estable, pero podría ser más rápido.</p>';
	    color = "#ffc107"; // Amarillo
	} else {
	    diagnostico = '<strong><p class="has-background-danger has-text-centered">Bajo:</p></strong> <p class="has-text-centered">Se recomienda revisar el ahorro de energía o procesos en segundo plano.</p>';
	    color = "#dc3545"; // Rojo
	}
    
    
    // -------------

    console.log(`Test finalizado en: ${total_duracionMs.toFixed(2)}ms. Control: ${control}`);
    console.log(`RESULTADO DEL TEST:\n\nVelocidad de procesado: ${duracionMs.toFixed(0)} unidades.\nDiagnóstico: ${diagnostico}`);
    
    let result1 = `Test finalizado en: ${total_duracionMs.toFixed(2)}ms.`;
    let result2 = `Control: ${control}`;
    let result3 = `Velocidad de procesado = ${duracionMs.toFixed(0)} unidades.`;
    let result4 = `Diagnóstico:${diagnostico}`;
    
    this.alertInfo = '<strong>RESULTADO DEL TEST DE VELOCIDAD</strong><br>' + result1 + '<br>' + result2  + '<br>' + result3 + '<br>' + result4;
		
	this.showInfoModal(true, this.alertInfo, '', null, 'info');
	
  } // End function testSpeedButtonClick

  // -------------------------------
  //  Ventanas modales informativas
  // -------------------------------

  showInfoModal(value: boolean, info: string, link: string, param: any, skin: string) {

    console.log('---->>>>.... Ejecutando APP showInfoModal: ' + value + ' ;Info: ' + info + ' ;Param: ' + param + ' ;Link: ' + link);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin}));

  } // End function showInfoModal

  confirmInfoModal() {
    console.log('---->>>>.... Ejecutando APP confirmInfoModal. Link = ' + this.linkInfo + ' ;Param = ' + this.paramInfo);

    this.navigateInfoModal();

    this.hideInfoModal();

  } // End function confirmInfoModal

  navigateInfoModal() {
    if (this.linkInfo !== '' && this.linkInfo !== null && this.linkInfo !== undefined) {
      if (this.paramInfo !== undefined && this.paramInfo !== null && this.paramInfo !== '') {
        console.log('---> Encontrado parámetro de enrutamiento: ');
        console.log(this.paramInfo);

        this.router.navigate([this.linkInfo, this.paramInfo]);
      } else {
        this.router.navigate([this.linkInfo]);
      }
    }
  } // End function navigateInfoModal

  hideInfoModal() {

    console.log('---->>>>.... Ejecutando APP hideInfoModal.');

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: false, info: '', link: '', param: null, skin: 'info'}));

  } // End function hideInfoModal


  showAlertModal(value: boolean, info: string) {

    console.log('---->>>>.... Ejecutando APP showAlertModal: ' + value + ' ;Info: ' + info);
    
    this.storeRoot.dispatch( new rootActions.ChangeAlertModal({value: true, info: info}));
    this.alertModal = value;
    this.alertInfo = info;

  } // End function showAlertModal

  confirmAlertModal() {
    console.log('---->>>>.... Ejecutando APP confirmAlertModal.');

    this.storeRoot.dispatch( new rootActions.ChangeAlertModal({value: false, info: ''}));
    // this.showAlertModal(false);

  } // End function confirmAlertModal

}
